import ClientSingleProduct from "./ClientSingleProduct";

export default ClientSingleProduct;
